Object.defineProperty(exports,"__esModule",{value:true});var _NativeMethodsMixin=require('../NativeMethodsMixin');var _NativeMethodsMixin2=_interopRequireDefault(_NativeMethodsMixin);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var applyNativeMethods=function applyNativeMethods(Component){Object.keys(_NativeMethodsMixin2.default).forEach(function(method){if(!Component.prototype[method]){Component.prototype[method]=_NativeMethodsMixin2.default[method];}});return Component;};exports.default=applyNativeMethods;


//////////////////
// WEBPACK FOOTER
// ./~/react-native-web/dist/modules/applyNativeMethods/index.js
// module id = 17
// module chunks = 0